exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-1fazp{width:100%;max-width:720px}@media screen and (min-height: 1000px){.modal-1fazp{margin-top:110px}}.cropContainer-fekbx{position:relative;height:400px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.btnContainer-2UOq5{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:40px 0 10px}.btnContainer-2UOq5 button:first-child{padding:0 20px}.btnContainer-2UOq5 button:not(:last-child){margin-right:40px}.isMainCheckbox-HPPq3{text-align:right;margin-top:10px}", ""]);

// exports
exports.locals = {
	"modal": "modal-1fazp",
	"cropContainer": "cropContainer-fekbx",
	"btnContainer": "btnContainer-2UOq5",
	"isMainCheckbox": "isMainCheckbox-HPPq3"
};